import React from "react";
import EiaDialog from "./EiaDialog";
import LoadingDialog from "./LoadingDialog";
import AlertCard from "../cards/AlertCard";
import {Flex, Heading} from "@aws-amplify/ui-react";
import EiaButton from "../EiaButton";
import EiaCard from "../cards/EiaCard";
import CurrencySelects from "../CurrencySelects";
import {getCurrencyTypeByCurrency} from "../../commons/enums/D4Enums";
import {d4EditAuction} from "../../commons/api/D4Api";
import Utils from "../../commons/Utils/Utils";
import * as ApiUtils from "../../commons/api/ApiUtils";

const isSmallScreen = Utils.isSmallScreen();

function BaseEditAuctionDialog(props) {
    const {alert, setAlert, onClose, open, auction, convertToItemForRequest, baseItem, game} = props;

    const [currency, setCurrency] = React.useState({})

    const [isLoading, setIsLoading] = React.useState(false)

    React.useEffect(() => {
        if(!auction) {
            return;
        }

        // update currency
        let currencyType = getCurrencyTypeByCurrency(auction.currency);
        let temp = {
            name: auction.currency,
            type: currencyType,
            price: auction.price
        }
        setCurrency(temp);
    }, [auction]);

    const save = function() {
        setIsLoading(true)

        const request = ApiUtils.getGameRequest(auction);

        const auctionForRequest = Object.assign({}, auction);
        auctionForRequest.item = convertToItemForRequest(request.game);
        auctionForRequest.amount = baseItem.amount;
        auctionForRequest.currency = currency.name;
        auctionForRequest.price = currency.price;

        request.auction= auctionForRequest;

        d4EditAuction(request, function (response) {
            let successMessage = baseItem.title ? "Successfully edited auction with item '" + response.updatedAuction.item.name + "'" :
                "Successfully edited auction with item '" + baseItem.name + "'";
            setAlert(["success", successMessage]);
            setIsLoading(false)
            onClose(true);
        }, function (error) {
            setAlert(["error", error.message]);
            setIsLoading(false)
        })
    }


    return (
        <EiaDialog title={"Edit Auction"} open={open} onClose={onClose} isLoading={isLoading} maxWidth={"xl"} fullWidth={isSmallScreen}>
            <LoadingDialog open={isLoading} />
            <AlertCard alert={alert} />
            <Flex direction={isSmallScreen ? "column" : "row"}>
                {props.children}
                <EiaCard>
                    <Flex direction="column" justifyContent="space-between">
                        <Heading level={5}>Currency</Heading>
                        <CurrencySelects currency={currency} setCurrency={setCurrency} addPrice={true} setAlert={setAlert} game={game} />
                        <EiaButton isFullWidth colorTheme={"success"} onClick={save} disabled={isLoading}>Save</EiaButton>
                    </Flex>
                </EiaCard>
            </Flex>
        </EiaDialog>
    );
}

export default BaseEditAuctionDialog;